export const logInfo = (message: string) => {
    console.log(
        JSON.stringify({
            level: 'info',
            status: 'info',
            message: `${message}`,
            timestamp: new Date().toISOString(),
            applicationLog: true,
        }),
    );
};

export const logError = (message: string, error?: Error) => {
    if (!error) {
        message = `${message}\nError: ${JSON.stringify(error)}`;
    }

    console.error(
        JSON.stringify({
            level: 'error',
            status: 'error',
            message,
            timestamp: new Date().toISOString(),
            applicationLog: true,
        }),
    );
};
